/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityInnTypes } from './FacilityInnTypes';
import {
    FacilityInnTypesFromJSON,
    FacilityInnTypesFromJSONTyped,
    FacilityInnTypesToJSON,
} from './FacilityInnTypes';

/**
 * 
 * @export
 * @interface EnabledPayer
 */
export interface EnabledPayer {
    /**
     * 
     * @type {string}
     * @memberof EnabledPayer
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof EnabledPayer
     */
    payer_type: EnabledPayerPayerTypeEnum;
    /**
     * 
     * @type {Array<FacilityInnTypes>}
     * @memberof EnabledPayer
     */
    inn_facilities: Array<FacilityInnTypes>;
}


/**
 * @export
 */
export const EnabledPayerPayerTypeEnum = {
    Standard: 'standard',
    Medicare: 'medicare',
    Medicaid: 'medicaid'
} as const;
export type EnabledPayerPayerTypeEnum = typeof EnabledPayerPayerTypeEnum[keyof typeof EnabledPayerPayerTypeEnum];


/**
 * Check if a given object implements the EnabledPayer interface.
 */
export function instanceOfEnabledPayer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "payer_type" in value;
    isInstance = isInstance && "inn_facilities" in value;

    return isInstance;
}

export function EnabledPayerFromJSON(json: any): EnabledPayer {
    return EnabledPayerFromJSONTyped(json, false);
}

export function EnabledPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnabledPayer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payor_id': json['payor_id'],
        'payer_type': json['payer_type'],
        'inn_facilities': ((json['inn_facilities'] as Array<any>).map(FacilityInnTypesFromJSON)),
    };
}

export function EnabledPayerToJSON(value?: EnabledPayer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payor_id': value.payor_id,
        'payer_type': value.payer_type,
        'inn_facilities': ((value.inn_facilities as Array<any>).map(FacilityInnTypesToJSON)),
    };
}

